<ng-template #newsCard let-news let-manage="manage" let-clickable="clickable" let-hideMeta="hideMeta" let-hideDate="hideDate">
  <div class="wrapper-list-thumb position-relative news-card"
    [class.news-admin-card]="manage"
    [class.news-card--no-meta]="hideMeta"
    [class.news-card--single-meta]="hideDate && !hideMeta"
    [class.news-card--out-of-range]="manage && isOutsidePublishRange(news)"
    [class.news-card-clickable]="clickable"
    [routerLink]="clickable ? ['/news', news._id] : null">
    <div class="news-card-header">
      <p class="news-card-heading-text">
        <span class="news-card-title primary-text"
          matTooltip="{{ news?.NewsName }}"
          matTooltipClass="title-tooltip">
          {{ news?.NewsName || 'No title available' }}
        </span>
      </p>

      <div class="news-card-meta" *ngIf="!hideMeta">
        <p class="news-card-location">
          <span class="material-symbols-outlined news-card-meta-icon" aria-hidden="true">fmd_good</span>
          <span class="news-location-text">{{ news?.Location || 'No location specified' }}</span>
        </p>
        <p class="news-card-date" *ngIf="!hideDate && (!manage || news?.VisibilityStartDate || news?.VisibilityEndDate)">
          <span class="material-icons news-card-meta-icon" aria-hidden="true">calendar_today</span>
          <ng-container *ngIf="manage; else publicationDate">
            <span *ngIf="news?.VisibilityStartDate">{{ news.VisibilityStartDate | date:'dd/MM/yyyy':'UTC' }}</span>
            <span class="news-range-separator" *ngIf="news?.VisibilityStartDate && news?.VisibilityEndDate">–</span>
            <span *ngIf="news?.VisibilityEndDate">{{ news.VisibilityEndDate | date:'dd/MM/yyyy':'UTC' }}</span>
          </ng-container>
          <ng-template #publicationDate>
            <span>{{ (news?.Date | date:'dd/MM/yyyy':'UTC') || 'No date specified' }}</span>
          </ng-template>
        </p>
      </div>
    </div>

    <div class="room-img-wrapper">
      <span class="news-out-of-range-badge" *ngIf="manage && isOutsidePublishRange(news)">
        Outside publish date range
      </span>
      <img [src]="news.NewsImages[0]" *ngIf="news.NewsImages && news.NewsImages.length; else otherImage" />
      <ng-template #otherImage>
        <img src="assets/images/No_Image_Available.jpg" />
      </ng-template>
    </div>

    <div class="button-section" *ngIf="manage" (click)="$event.stopPropagation()">
      <button type="button" class="btn btn-primary" (click)="viewDetail(news._id)"
        [appAccessCheck]="'news'" [givenButton]="'view'">
        <i class="material-icons">remove_red_eye</i>{{ 'ViewDetail' | translate }}
      </button>
      <button class="btn btn-secondary" type="button" (click)="editNews(news._id)"
        [appAccessCheck]="'news'" [givenButton]="'edit'">
        <i class="material-icons">create</i>{{ 'Edit' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<div class="room-manage-page" *ngIf="isManagePage">
  <div class="content-section-outer w-100">
    <div class="content-wrapper">
      <div class="main-content-wrapper">
        <div class="home-page row mx-0 w-100">
          <div class="gallery-item-list news-card-item col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let news of serviceResponseArrayModel.ServiceLists">
            <ng-container *ngTemplateOutlet="newsCard; context: { $implicit: news, manage: true, clickable: false, hideDate: true }">
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="room-manage-page" *ngIf="homePage">
  <div class="content-section-outer w-100">
    <div class="content-wrapper">
      <div class="main-content-wrapper">
        <div class="home-page row mx-0 w-100">
          <div class="gallery-item-list news-card-item col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let news of serviceResponseArrayModel.ServiceLists | slice:0:4">
            <ng-container *ngTemplateOutlet="newsCard; context: { $implicit: news, manage: false, clickable: true }">
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="room-manage-page" *ngIf="newsLocationStatus === 'homePage'">
  <div class="content-section-outer w-100">
    <div class="content-wrapper">
      <div class="main-content-wrapper">
        <div class="home-page row mx-0 w-100">
          <div class="gallery-item-list news-card-item col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let news of serviceResponseArrayModel.ServiceLists | slice:0:4">
            <ng-container *ngTemplateOutlet="newsCard; context: { $implicit: news, manage: false, clickable: false }">
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="room-manage-page" *ngIf="guestPage">
  <div class="content-section-outer w-100">
    <div class="content-wrapper">
      <div class="main-content-wrapper">
        <div class="home-page row mx-0 w-100">
          <div class="gallery-item-list news-card-item col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
            *ngFor="let news of serviceResponseArrayModel.ServiceLists">
            <ng-container *ngTemplateOutlet="newsCard; context: { $implicit: news, manage: false, clickable: true, hideDate: true }">
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
